import PeopleEducation from './PeopleEducation';

export { type PeopleEducationProps } from './PeopleEducation';
export default PeopleEducation;
